enum TagTypesEnum {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  Three = 'THREE',
  Four = 'FOUR',
  Five = 'FIVE',
  Square = 'SQUARE',
}

export default TagTypesEnum;
